"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlGrantRoleDialog = exports.grantRoleFieldsValidation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
var validation_1 = require("./validation");
Object.defineProperty(exports, "grantRoleFieldsValidation", { enumerable: true, get: function () { return validation_1.grantRoleFieldsValidation; } });
const AccessControlGrantRoleDialog = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "role", options: types_1.AccessControlRoleType, required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.ComboEntityInput, { name: "address", controller: "contracts", targetId: "address", freeSolo: true, required: true })] }));
};
exports.AccessControlGrantRoleDialog = AccessControlGrantRoleDialog;
//# sourceMappingURL=index.js.map